import React from "react";
import { Drawer, Box } from "@mui/material";

const MenuDrawer = ({ open, onClose, children }) => {
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 1300,
      }}
      PaperProps={{
        sx: {
          width: 350,
          backgroundColor: "#f2f2f2",
          borderRadius: "0px 30px 0px 0px",
        },
      }}
    >
      <Box sx={{ p: 2, height: "100%" }}>{children}</Box>
    </Drawer>
  );
};

export default MenuDrawer;
